export const EvaluationInfoEnum = {
EvaluationStepInfo: "EvaluationStepInfo",
EvaluationInfo: "EvaluationInfo",
ourLawInfo: "ourLawInfo",
updateConnectionInfo: "updateConnectionInfo",
OurLawCheckListInfo:"OurLawCheckListInfo",
OtherRequirementCheckListInfo:"OtherRequirementCheckListInfo"
};

export const EvaluationInfoType = Object.values(EvaluationInfoEnum);